import clsx from "clsx";
import Flex, { GAP_CLASS } from "components/Flex";
import { ALIGN_CLASS, DIRECTION_CLASS } from "components/Flex/Flex";
import {
  arrayOf,
  bool,
  func,
  node,
  number,
  oneOf,
  oneOfType,
  shape,
  string,
} from "prop-types";

import classes from "./ChoiceGroup.module.scss";

export const choiceGroupLayouts = {
  row: "row",
  column: "column",
};

const ChoiceGroup = ({
  question,
  layout = choiceGroupLayouts.row,
  options,
  value,
  onChange,
  disabled = false,
  fullWidthOptions = false,
  className,
}) => {
  const isRow = layout === choiceGroupLayouts.row;

  return (
    <Flex
      direction={isRow ? DIRECTION_CLASS.row : DIRECTION_CLASS.column}
      alignItems={isRow ? ALIGN_CLASS.center : ALIGN_CLASS.stretch}
      justifyContent={isRow ? "space-between" : "flex-start"}
      gap={isRow ? GAP_CLASS.GAP_300 : GAP_CLASS.GAP_200}
      className={clsx(classes["choice_group"], className)}
    >
      {question && <div className={classes["choice_group__question"]}>{question}</div>}
      <Flex
        gap={GAP_CLASS.GAP_200}
        className={clsx(classes["choice_group__options"], {
          [classes["choice_group__options--full_width"]]: fullWidthOptions,
        })}
      >
        {options.map((option) => {
          const isSelected = option.value === value;

          return (
            <button
              key={String(option.value)}
              type="button"
              className={clsx(classes["choice_group__button"], {
                [classes["choice_group__button--selected"]]: isSelected,
                [classes["choice_group__button--full_width"]]: fullWidthOptions,
              })}
              disabled={disabled}
              aria-label={option.ariaLabel}
              aria-pressed={isSelected}
              onClick={() => onChange(option.value)}
            >
              {option.label}
            </button>
          );
        })}
      </Flex>
    </Flex>
  );
};

ChoiceGroup.propTypes = {
  question: node,
  layout: oneOf(Object.values(choiceGroupLayouts)),
  options: arrayOf(
    shape({
      value: oneOfType([string, bool, number]).isRequired,
      label: node.isRequired,
      ariaLabel: string,
    })
  ).isRequired,
  value: oneOfType([string, bool, number]),
  onChange: func.isRequired,
  disabled: bool,
  fullWidthOptions: bool,
  className: string,
};

export default ChoiceGroup;
